const baseUrl = "https://api.hydraflasher.com/";
// const baseUrl = "http://localhost:3002/";
const coinbase_invoiceUrl = "https://commerce.coinbase.com/invoices/";

async function getPublicIP() {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error(error);
  }
}
// const invoiceRoute = baseUrl + "user/productinvoice";
const invoiceRoute = baseUrl + "invoices";
const isCouponValid = baseUrl + "invoices/isCouponValid";
const allTransactions = baseUrl + "all-tnx";
const loginRoute = baseUrl + "user/login";
const getUser = baseUrl + "user";
const registerRoute = baseUrl + "user/register";
const BuyProductUrl = baseUrl + "invoices/get_address";
const EscrowBlockonomics = baseUrl + "invoices/escrow/address/generate";
const UpdateInvoiceUrl = baseUrl + "invoices";
const NewsUrl = baseUrl + "news";

const NoticeUrl = baseUrl + "notice";

const ScamReportUrl = baseUrl + "scam_report";

const ScamReportPostUrl = baseUrl + "scam_report/create-scam-report";
const RefundReq = baseUrl + "refund-request";
const RefundReqGet = baseUrl + "refund-request/get";

const NowPaymentsCreatePaymentUrl = baseUrl + "api/nowpayments/create-payment";
const NowPaymentsCurrenciesUrl = baseUrl + "api/nowpayments/currencies";
const nowPaymentWebhookUrl = baseUrl + "api/nowpayments/webhook";
const NowPaymentsInvoicesByCustomerUrl =
  baseUrl + "api/nowpayments/invoices/customer";

export {
  allTransactions,
  baseUrl,
  BuyProductUrl,
  coinbase_invoiceUrl,
  EscrowBlockonomics,
  getPublicIP,
  getUser,
  invoiceRoute,
  isCouponValid,
  loginRoute,
  NewsUrl,
  NoticeUrl,
  NowPaymentsCreatePaymentUrl,
  NowPaymentsCurrenciesUrl,
  NowPaymentsInvoicesByCustomerUrl,
  nowPaymentWebhookUrl,
  RefundReq,
  RefundReqGet,
  registerRoute,
  ScamReportPostUrl,
  ScamReportUrl,
  UpdateInvoiceUrl,
};
